/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateApiSmsRouteDto } from '../model/createApiSmsRouteDto';
import { CreateSmppSmsRouteDto } from '../model/createSmppSmsRouteDto';
import { PaginatedModelOfRouteByGroupResponse } from '../model/paginatedModelOfRouteByGroupResponse';
import { RouteAction } from '../model/routeAction';
import { RouteCreationResonse } from '../model/routeCreationResonse';
import { RouteTypeEnum } from '../model/routeTypeEnum';
import { ServerTypeEnum } from '../model/serverTypeEnum';
import { SmsRouteDtos } from '../model/smsRouteDtos';
import { SmsRouteGroupDto } from '../model/smsRouteGroupDto';
import { SmsRouteGroupModel } from '../model/smsRouteGroupModel';
import { SmsRouteOfObject } from '../model/smsRouteOfObject';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsRoutesService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesAddAPISmsRoute(model: CreateApiSmsRouteDto, observe?: 'body', reportProgress?: boolean): Observable<RouteCreationResonse>;
    public smsRoutesAddAPISmsRoute(model: CreateApiSmsRouteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCreationResonse>>;
    public smsRoutesAddAPISmsRoute(model: CreateApiSmsRouteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCreationResonse>>;
    public smsRoutesAddAPISmsRoute(model: CreateApiSmsRouteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutesAddAPISmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<RouteCreationResonse>(`${this.basePath}/api/SmsRoutes/createapismsroute`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesAddSmppSmsRoute(model: CreateSmppSmsRouteDto, observe?: 'body', reportProgress?: boolean): Observable<RouteCreationResonse>;
    public smsRoutesAddSmppSmsRoute(model: CreateSmppSmsRouteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCreationResonse>>;
    public smsRoutesAddSmppSmsRoute(model: CreateSmppSmsRouteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCreationResonse>>;
    public smsRoutesAddSmppSmsRoute(model: CreateSmppSmsRouteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutesAddSmppSmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<RouteCreationResonse>(`${this.basePath}/api/SmsRoutes/createsmpproute`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesCreateSmsRouteGroup(model: SmsRouteGroupModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsRoutesCreateSmsRouteGroup(model: SmsRouteGroupModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsRoutesCreateSmsRouteGroup(model: SmsRouteGroupModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsRoutesCreateSmsRouteGroup(model: SmsRouteGroupModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutesCreateSmsRouteGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/SmsRoutes/CreateSmsRouteGroup`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesDeleteRouteAction(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsRoutesDeleteRouteAction(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsRoutesDeleteRouteAction(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsRoutesDeleteRouteAction(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete(`${this.basePath}/api/SmsRoutes/DeleteRouteAction`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesDeleteRouteGroup(id?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsRoutesDeleteRouteGroup(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsRoutesDeleteRouteGroup(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsRoutesDeleteRouteGroup(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/SmsRoutes/DeleteRouteGroup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteGuid 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesDeleteSmsRoute(smsRouteGuid?: string, spId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsRoutesDeleteSmsRoute(smsRouteGuid?: string, spId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsRoutesDeleteSmsRoute(smsRouteGuid?: string, spId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsRoutesDeleteSmsRoute(smsRouteGuid?: string, spId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsRouteGuid !== undefined && smsRouteGuid !== null) {
            queryParameters = queryParameters.set('smsRouteGuid', <any>smsRouteGuid);
        }
        if (spId !== undefined && spId !== null) {
            queryParameters = queryParameters.set('spId', <any>spId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<string>(`${this.basePath}/api/SmsRoutes/deletesmsroute`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param searchWord 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetAllRouteGroupByRouteGroup(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfRouteByGroupResponse>;
    public smsRoutesGetAllRouteGroupByRouteGroup(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfRouteByGroupResponse>>;
    public smsRoutesGetAllRouteGroupByRouteGroup(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfRouteByGroupResponse>>;
    public smsRoutesGetAllRouteGroupByRouteGroup(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfRouteByGroupResponse>(`${this.basePath}/api/SmsRoutes/GetAllRouteGroupByRouteGroup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param searchWord 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetAllRouteGroups(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteGroupDto>;
    public smsRoutesGetAllRouteGroups(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteGroupDto>>;
    public smsRoutesGetAllRouteGroups(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteGroupDto>>;
    public smsRoutesGetAllRouteGroups(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteGroupDto>(`${this.basePath}/api/SmsRoutes/GetAllRouteGroups`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteName 
     * @param creatorId 
     * @param includedefault 
     * @param serverType 
     * @param startIndex 
     * @param count 
     * @param excludeContentBasedRoutes 
     * @param searchword 
     * @param groupname 
     * @param istoplevel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetAllSmsRoutes(smsRouteName?: string, creatorId?: string, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteDtos>;
    public smsRoutesGetAllSmsRoutes(smsRouteName?: string, creatorId?: string, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteDtos>>;
    public smsRoutesGetAllSmsRoutes(smsRouteName?: string, creatorId?: string, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteDtos>>;
    public smsRoutesGetAllSmsRoutes(smsRouteName?: string, creatorId?: string, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsRouteName !== undefined && smsRouteName !== null) {
            queryParameters = queryParameters.set('smsRouteName', <any>smsRouteName);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (includedefault !== undefined && includedefault !== null) {
            queryParameters = queryParameters.set('includedefault', <any>includedefault);
        }
        if (serverType !== undefined && serverType !== null) {
            queryParameters = queryParameters.set('serverType', <any>serverType);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (excludeContentBasedRoutes !== undefined && excludeContentBasedRoutes !== null) {
            queryParameters = queryParameters.set('excludeContentBasedRoutes', <any>excludeContentBasedRoutes);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }
        if (groupname !== undefined && groupname !== null) {
            queryParameters = queryParameters.set('groupname', <any>groupname);
        }
        if (istoplevel !== undefined && istoplevel !== null) {
            queryParameters = queryParameters.set('istoplevel', <any>istoplevel);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteDtos>(`${this.basePath}/api/SmsRoutes/GetAllSmsRoutes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteName 
     * @param creatorId 
     * @param includedefault 
     * @param serverType 
     * @param startIndex 
     * @param count 
     * @param excludeContentBasedRoutes 
     * @param searchword 
     * @param groupname 
     * @param istoplevel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetAllSystemSmsRoutes(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteDtos>;
    public smsRoutesGetAllSystemSmsRoutes(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteDtos>>;
    public smsRoutesGetAllSystemSmsRoutes(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteDtos>>;
    public smsRoutesGetAllSystemSmsRoutes(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, excludeContentBasedRoutes?: boolean, searchword?: string, groupname?: string, istoplevel?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsRouteName !== undefined && smsRouteName !== null) {
            queryParameters = queryParameters.set('smsRouteName', <any>smsRouteName);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (includedefault !== undefined && includedefault !== null) {
            queryParameters = queryParameters.set('includedefault', <any>includedefault);
        }
        if (serverType !== undefined && serverType !== null) {
            queryParameters = queryParameters.set('serverType', <any>serverType);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (excludeContentBasedRoutes !== undefined && excludeContentBasedRoutes !== null) {
            queryParameters = queryParameters.set('excludeContentBasedRoutes', <any>excludeContentBasedRoutes);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }
        if (groupname !== undefined && groupname !== null) {
            queryParameters = queryParameters.set('groupname', <any>groupname);
        }
        if (istoplevel !== undefined && istoplevel !== null) {
            queryParameters = queryParameters.set('istoplevel', <any>istoplevel);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteDtos>(`${this.basePath}/api/SmsRoutes/GetAllSystemSmsRoutes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param groupName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetGroupType(creatorId?: string, groupName?: string, observe?: 'body', reportProgress?: boolean): Observable<RouteTypeEnum>;
    public smsRoutesGetGroupType(creatorId?: string, groupName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteTypeEnum>>;
    public smsRoutesGetGroupType(creatorId?: string, groupName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteTypeEnum>>;
    public smsRoutesGetGroupType(creatorId?: string, groupName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (groupName !== undefined && groupName !== null) {
            queryParameters = queryParameters.set('groupName', <any>groupName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RouteTypeEnum>(`${this.basePath}/api/SmsRoutes/GetGroupType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param groupName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetSmsRouteByGroupName(groupName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsRouteOfObject>>;
    public smsRoutesGetSmsRouteByGroupName(groupName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsRouteOfObject>>>;
    public smsRoutesGetSmsRouteByGroupName(groupName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsRouteOfObject>>>;
    public smsRoutesGetSmsRouteByGroupName(groupName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupName !== undefined && groupName !== null) {
            queryParameters = queryParameters.set('groupName', <any>groupName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SmsRouteOfObject>>(`${this.basePath}/api/SmsRoutes/GetSmsRouteByGroupName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteGuidString 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetSmsRouteById(smsRouteGuidString?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteOfObject>;
    public smsRoutesGetSmsRouteById(smsRouteGuidString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteOfObject>>;
    public smsRoutesGetSmsRouteById(smsRouteGuidString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteOfObject>>;
    public smsRoutesGetSmsRouteById(smsRouteGuidString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsRouteGuidString !== undefined && smsRouteGuidString !== null) {
            queryParameters = queryParameters.set('smsRouteGuidString', <any>smsRouteGuidString);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteOfObject>(`${this.basePath}/api/SmsRoutes/GetSmsRouteById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesGetSmsRouteByName(smsRouteName?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteOfObject>;
    public smsRoutesGetSmsRouteByName(smsRouteName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteOfObject>>;
    public smsRoutesGetSmsRouteByName(smsRouteName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteOfObject>>;
    public smsRoutesGetSmsRouteByName(smsRouteName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsRouteName !== undefined && smsRouteName !== null) {
            queryParameters = queryParameters.set('smsRouteName', <any>smsRouteName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteOfObject>(`${this.basePath}/api/SmsRoutes/GetSmsRouteByName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesUpdateAllRouteGroupThatCreatorIdIsNull(creatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsRoutesUpdateAllRouteGroupThatCreatorIdIsNull(creatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsRoutesUpdateAllRouteGroupThatCreatorIdIsNull(creatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsRoutesUpdateAllRouteGroupThatCreatorIdIsNull(creatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<boolean>(`${this.basePath}/api/SmsRoutes/UpdateAllRouteGroupThatCreatorIdIsNull`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesUpdateRouteAction(model: RouteAction, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsRoutesUpdateRouteAction(model: RouteAction, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsRoutesUpdateRouteAction(model: RouteAction, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsRoutesUpdateRouteAction(model: RouteAction, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutesUpdateRouteAction.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SmsRoutes/UpdateRouteAction`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesUpdateRouteGroup(model: SmsRouteGroupModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsRoutesUpdateRouteGroup(model: SmsRouteGroupModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsRoutesUpdateRouteGroup(model: SmsRouteGroupModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsRoutesUpdateRouteGroup(model: SmsRouteGroupModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutesUpdateRouteGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SmsRoutes/UpdateRouteGroup`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param creatorId 
     * @param isOwnedByCoure 
     * @param operatorCode 
     * @param entityStatusEnum 
     * @param routeCanAllowMultipleBinds 
     * @param publicName 
     * @param groupIdentifier 
     * @param accessType 
     * @param isTopLevel 
     * @param smsRouteName 
     * @param description 
     * @param serverType 
     * @param operatorId 
     * @param rate 
     * @param active 
     * @param dateCreated 
     * @param smsRouteServer 
     * @param isContentRetrievalRoute 
     * @param networkCode 
     * @param routeTypeName 
     * @param country 
     * @param countryCode 
     * @param MNC 
     * @param MCC 
     * @param contentBasedRouteName 
     * @param routeType 
     * @param isLocal 
     * @param defaultRoute 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesUpdateSmsRoute(id: string, creatorId: string, isOwnedByCoure: boolean, operatorCode: string, entityStatusEnum: number, routeCanAllowMultipleBinds: boolean, publicName: string, groupIdentifier: string, accessType: string, isTopLevel: boolean, smsRouteName: string, description: string, serverType: number, operatorId: number, rate: number, active: boolean, dateCreated: Date, smsRouteServer: any, isContentRetrievalRoute: boolean, networkCode: string, routeTypeName: string, country: string, countryCode: string, MNC: string, MCC: string, contentBasedRouteName: string, routeType: number, isLocal: boolean, defaultRoute: boolean, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsRoutesUpdateSmsRoute(id: string, creatorId: string, isOwnedByCoure: boolean, operatorCode: string, entityStatusEnum: number, routeCanAllowMultipleBinds: boolean, publicName: string, groupIdentifier: string, accessType: string, isTopLevel: boolean, smsRouteName: string, description: string, serverType: number, operatorId: number, rate: number, active: boolean, dateCreated: Date, smsRouteServer: any, isContentRetrievalRoute: boolean, networkCode: string, routeTypeName: string, country: string, countryCode: string, MNC: string, MCC: string, contentBasedRouteName: string, routeType: number, isLocal: boolean, defaultRoute: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsRoutesUpdateSmsRoute(id: string, creatorId: string, isOwnedByCoure: boolean, operatorCode: string, entityStatusEnum: number, routeCanAllowMultipleBinds: boolean, publicName: string, groupIdentifier: string, accessType: string, isTopLevel: boolean, smsRouteName: string, description: string, serverType: number, operatorId: number, rate: number, active: boolean, dateCreated: Date, smsRouteServer: any, isContentRetrievalRoute: boolean, networkCode: string, routeTypeName: string, country: string, countryCode: string, MNC: string, MCC: string, contentBasedRouteName: string, routeType: number, isLocal: boolean, defaultRoute: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsRoutesUpdateSmsRoute(id: string, creatorId: string, isOwnedByCoure: boolean, operatorCode: string, entityStatusEnum: number, routeCanAllowMultipleBinds: boolean, publicName: string, groupIdentifier: string, accessType: string, isTopLevel: boolean, smsRouteName: string, description: string, serverType: number, operatorId: number, rate: number, active: boolean, dateCreated: Date, smsRouteServer: any, isContentRetrievalRoute: boolean, networkCode: string, routeTypeName: string, country: string, countryCode: string, MNC: string, MCC: string, contentBasedRouteName: string, routeType: number, isLocal: boolean, defaultRoute: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (creatorId === null || creatorId === undefined) {
            throw new Error('Required parameter creatorId was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (isOwnedByCoure === null || isOwnedByCoure === undefined) {
            throw new Error('Required parameter isOwnedByCoure was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (operatorCode === null || operatorCode === undefined) {
            throw new Error('Required parameter operatorCode was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (entityStatusEnum === null || entityStatusEnum === undefined) {
            throw new Error('Required parameter entityStatusEnum was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (routeCanAllowMultipleBinds === null || routeCanAllowMultipleBinds === undefined) {
            throw new Error('Required parameter routeCanAllowMultipleBinds was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (publicName === null || publicName === undefined) {
            throw new Error('Required parameter publicName was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (groupIdentifier === null || groupIdentifier === undefined) {
            throw new Error('Required parameter groupIdentifier was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (accessType === null || accessType === undefined) {
            throw new Error('Required parameter accessType was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (isTopLevel === null || isTopLevel === undefined) {
            throw new Error('Required parameter isTopLevel was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (smsRouteName === null || smsRouteName === undefined) {
            throw new Error('Required parameter smsRouteName was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (description === null || description === undefined) {
            throw new Error('Required parameter description was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (serverType === null || serverType === undefined) {
            throw new Error('Required parameter serverType was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (operatorId === null || operatorId === undefined) {
            throw new Error('Required parameter operatorId was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (rate === null || rate === undefined) {
            throw new Error('Required parameter rate was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (active === null || active === undefined) {
            throw new Error('Required parameter active was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (dateCreated === null || dateCreated === undefined) {
            throw new Error('Required parameter dateCreated was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (smsRouteServer === null || smsRouteServer === undefined) {
            throw new Error('Required parameter smsRouteServer was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (isContentRetrievalRoute === null || isContentRetrievalRoute === undefined) {
            throw new Error('Required parameter isContentRetrievalRoute was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (networkCode === null || networkCode === undefined) {
            throw new Error('Required parameter networkCode was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (routeTypeName === null || routeTypeName === undefined) {
            throw new Error('Required parameter routeTypeName was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (country === null || country === undefined) {
            throw new Error('Required parameter country was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (MNC === null || MNC === undefined) {
            throw new Error('Required parameter MNC was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (MCC === null || MCC === undefined) {
            throw new Error('Required parameter MCC was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (contentBasedRouteName === null || contentBasedRouteName === undefined) {
            throw new Error('Required parameter contentBasedRouteName was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (routeType === null || routeType === undefined) {
            throw new Error('Required parameter routeType was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (isLocal === null || isLocal === undefined) {
            throw new Error('Required parameter isLocal was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        if (defaultRoute === null || defaultRoute === undefined) {
            throw new Error('Required parameter defaultRoute was null or undefined when calling smsRoutesUpdateSmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<string>(`${this.basePath}/api/SmsRoutes/putsmsroute`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param serverType 
     * @param routeType 
     * @param routeGroup 
     * @param mcc 
     * @param mnc 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutesValidateNetwork(serviceProviderId?: string, serverType?: number, routeType?: number, routeGroup?: string, mcc?: string, mnc?: string, observe?: 'body', reportProgress?: boolean): Observable<ServerTypeEnum>;
    public smsRoutesValidateNetwork(serviceProviderId?: string, serverType?: number, routeType?: number, routeGroup?: string, mcc?: string, mnc?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServerTypeEnum>>;
    public smsRoutesValidateNetwork(serviceProviderId?: string, serverType?: number, routeType?: number, routeGroup?: string, mcc?: string, mnc?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServerTypeEnum>>;
    public smsRoutesValidateNetwork(serviceProviderId?: string, serverType?: number, routeType?: number, routeGroup?: string, mcc?: string, mnc?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (serverType !== undefined && serverType !== null) {
            queryParameters = queryParameters.set('serverType', <any>serverType);
        }
        if (routeType !== undefined && routeType !== null) {
            queryParameters = queryParameters.set('routeType', <any>routeType);
        }
        if (routeGroup !== undefined && routeGroup !== null) {
            queryParameters = queryParameters.set('routeGroup', <any>routeGroup);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServerTypeEnum>(`${this.basePath}/api/SmsRoutes/ValidateNetwork`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
